{
  "signInTitle": "Sign in",
  "signInLead": "Sign in to register for programs, follow offices and track your reports.",
  "signUpTitle": "Create your account",
  "signUpLead": "One account for every office's schedules, programs and registrations.",
  "fullName": "Full name",
  "passwordHint": "At least 10 characters.",
  "forgot": "Forgot your password?",
  "noAccount": "No account yet?",
  "haveAccount": "Already have an account?",
  "resetTitle": "Reset your password",
  "resetLead": "Enter your email and we'll send you a link to choose a new password.",
  "resetSent": "If that email has an account, a reset link is on its way. Check your inbox.",
  "newPassword": "New password",
  "setPassword": "Set password",
  "passwordChanged": "Your password was changed. Please sign in.",
  "verifyTitle": "Confirming your email…",
  "verified": "Your email is confirmed. Thank you!",
  "verifyBanner": "Please confirm your email address. We sent you a link.",
  "resendVerification": "Send the link again",
  "inviteTitle": "Activate your staff account",
  "inviteLead": "You were invited to join {office} as {role}.",
  "activate": "Activate account",
  "guestNote": "You don't need an account to report an emergency.",
  "consentSignUp": "I agree that the LGU may store my account details to provide these services, as described in the privacy notice (RA 10173).",
  "showPassword": "Show password",
  "hidePassword": "Hide password",
  "signingIn": "Signing in…",
  "creating": "Creating your account…",
  "sending": "Sending…",
  "activating": "Activating…",
  "mobileHint": "For SMS reminders. Example: 0917 123 4567",
  "barangayHint": "We show your barangay's posts first.",
  "nameRequired": "Enter your full name.",
  "emailRequired": "Enter your email address.",
  "emailInvalid": "Enter a valid email address.",
  "passwordRequired": "Enter your password.",
  "passwordShort": "Use at least 10 characters.",
  "consentRequired": "Please agree to the privacy notice to continue.",
  "staffNote": "Work for the LGU? Staff accounts are created by invitation from your office, not here.",
  "welcomeTitle": "Welcome, {name}!",
  "checkEmail": "We sent a confirmation link to {email}. Open it to confirm your email address. You can use the app while you wait.",
  "continue": "Continue",
  "followSuggestion": "Choose offices to follow",
  "linkSent": "We sent a new link. Check your inbox.",
  "alreadyVerified": "Your email is already confirmed.",
  "sendResetLink": "Send reset link",
  "backToSignIn": "Back to sign in",
  "resetNewLead": "Choose a new password. You will be signed out on your other devices.",
  "linkInvalidTitle": "This link doesn't work",
  "linkMissing": "The link is incomplete. Open it again from your email, or ask for a new one.",
  "requestNewLink": "Ask for a new link",
  "verifyFailedTitle": "We couldn't confirm your email",
  "signInToResend": "Sign in to get a new confirmation link.",
  "goToApp": "Go to the app",
  "inviteLeadGeneric": "You were invited to the LGU staff workspace.",
  "inviteEmail": "Your staff account",
  "inviteExpiredTitle": "This invitation can't be used",
  "inviteMobileHint": "Your office may use it to reach you.",
  "inviteChecking": "Checking your invitation…"
}
